import { render, staticRenderFns } from "./IconSvgMEMAHome.vue?vue&type=template&id=6a6c6ac2&scoped=true&"
import script from "./IconSvgMEMAHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgMEMAHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c6ac2",
  null
  
)

export default component.exports